import { render, staticRenderFns } from "./aiwish.vue?vue&type=template&id=5fc70e3b&scoped=true&"
import script from "./aiwish.vue?vue&type=script&lang=js&"
export * from "./aiwish.vue?vue&type=script&lang=js&"
import style0 from "./aiwish.vue?vue&type=style&index=0&id=5fc70e3b&scoped=true&lang=less&"
import style1 from "./aiwish.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc70e3b",
  null
  
)

export default component.exports